export class BookingApiRoutes {
    public static MISSED = 'missed';
    public static KMS = 'kms';
    public static NOTIFIED = 'notified';
    public static MULTIPLE = 'multiple';
    public static JOURNEY = 'journey';
    public static TICKET_STATUS = 'ticket/status';
}